import { Outlet } from 'react-router-dom';

import {
    ErrorBoundary,
    FlagProviderWrapper,
    SyncModalPortal,
    UnsupportedDeviceBlocker,
} from '@register-ui/components';
import {
    BackgroundJobManager,
    CartPersistenceManager,
    FirestoreSyncManager,
    logger,
    useAutoStaffLogout,
} from '@register-ui/utils';

import { MigrateAuthToken } from './migrate-auth-token';

import { DeviceTimeGuard } from '@/features/shared/device-time-guard';
import { SystemBanner } from '@/features/shared/system-banner';

export function RouteWrapper() {
    useAutoStaffLogout();

    return (
        <FlagProviderWrapper>
            <ErrorBoundary logger={logger}>
                <FirestoreSyncManager />
                <BackgroundJobManager />
                <CartPersistenceManager />
                <MigrateAuthToken />
                <SyncModalPortal />

                <div className='flex h-dvh flex-col'>
                    <SystemBanner />
                    <UnsupportedDeviceBlocker>
                        <DeviceTimeGuard>
                            <Outlet />
                        </DeviceTimeGuard>
                    </UnsupportedDeviceBlocker>
                </div>
            </ErrorBoundary>
        </FlagProviderWrapper>
    );
}
